<template>
  <div :style="{paddingTop: top?'10px':0}">
    <!-- 筛选 -->
    <ScreenSort  @changeobj="changeobj" :config="['secondCategory','teamScreen','locationAddress']" :secondCategoryi="3" :getquery="true" :teamSizeType="teamType"></ScreenSort>
    <!-- 排序按钮组 -->
    <SortBtn :update="update" :isShowDistance="false" :isTeam="true"></SortBtn>
    <!-- 施工队班组工队列表 -->
    <div class="table" v-loading="loadingTrue">
      <div style="padding: 0 20px 10px 20px">
        <el-row :gutter="20" v-if="list.length">
          <el-col v-for="(item, index) in list" :span="12" :key="index">
            <card :item="item" :type="1" :index="index" :showIndex="false"></card>
          </el-col>
          <template>
            <el-col :span="24" class="course-loading-wrap" v-show="moreLoading">
              数据加载中... <i class="el-icon-loading loading-icon"></i>
            </el-col>
            <el-col :span="24" class="course-loading-wrap" v-show="!moreLoading && nomore">没有更多数据了!</el-col>
          </template>
        </el-row>

        <div v-if="!list.length && !loadingTrue" style="width: 1200px; margin: 0 auto;">
          <BaseEmptyData></BaseEmptyData>
        </div>
      </div>
    </div>
    <!-- 分页器 -->
    <!-- <Pagination
      v-if="param.total>0 && !loadingTrue"
      :param="param"
      @change="listFun"
      :loadingTrue="loadingTrue"
    ></Pagination> -->
  </div>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
import SortBtn from "@/components/sortBtnGroup/SortBtn"
import sessionStorage from "@/storage/sessionStorage"
const throttle = require("lodash/throttle");
export default {
  name: "constructionTeam",
  components: {
    ScreenSort: () =>import("@/components/screenSort/screenSort"),
    Pagination: () => import("@/components/card/page"),
    card:() => import("@/components/card/cardTeam.vue"),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    SortBtn
  },
  props: {
    top: {
      type:Boolean,
      default:true
    },
    // 工队类型，0：施工队；1：班组工队
    teamType:{
        type:Number,
        default:0
    }
  },
  data() {
    return {
      loadingTrue: true,
      moreLoading: false, //加载更多
      nomore: false, //没有数据显示
      list: [],
      params: {},
      param:{
        page:1,
        totalPages:0,
        limit:40,
        total:0,
        sortType:'1'
      },
      update:true
    }
  },
  watch: {
    // 页数改变的时候
    "param.page": {
      handler(val) {
        if (val > this.param.totalPages) {
          this.nomore = true;
        } else {
          this.nomore = false;
        }
      },
    },
  },
  methods: {
    listFun() {
      this.moreLoading = true //加载更多显示
      let params={...this.params}
      params.page=this.param.page
      params.limit=this.param.limit
      params.sortType = this.param.sortType
      if(process.env.VUE_APP_NAME ==="production"){
        params.profile='pro'
      }else if(process.env.VUE_APP_NAME==='pre'){
        params.profile='pro'
      }else if(process.env.VUE_APP_NAME==='development'){
        params.profile='dev'
      }
      apiResignAll
        .teamInfoSearchList(params)
        .then(({ data }) => {
          if (data.code === 200) {
            if (data.data.records) {
              if (data.data.records.length) {
                this.param.totalPages=data.data.pages
                this.param.total  = data.data.total
                this.list = [...this.list,...data.data.records]
                this.moreLoading = false //加载更多隐藏  
              }
            }
          }
        })
        .catch(error => {
          this.$message.error("msg")
        })
        .finally(() => {
          this.loadingTrue = false
        })
    },
    // 页面滚动
    windowScroll: throttle(
      function () {
        // 如果当前页数大于总页数 则不去获取
        // this.$nextTick(() => {
        let scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        let clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        /**
         * clientHeight 视口大小
         * scrollHeight 文档高度
         */
        if (scrollTop + clientHeight >= scrollHeight - 300) {
          this.param.page += 1;
          if (this.param.page <= this.param.totalPages) {
            this.listFun()
          }
        }
        // })
        // this.backUPVisible = scrollTop >= clientHeight
      },
      1500,
      { leading: false, trailing: true }
    ),
    changeobj(obj){
      this.param.page=1
      this.list = []
      this.loadingTrue = true
      for(let i in this.params){
        this.params[i]=''
      }
      this.params.teamType=this.teamType;
      this.params.firstCategoryNo=this.$store.state.firstCategoryNo ? this.$store.state.firstCategoryNo :'';
      let t=this;
      ['firstCategoryNo','secondCategoryNo','thirdCategoryNo','fourCategoryNo','fifthCategoryNo','sixthCategoryNo'].forEach((v,i)=>{
        if(obj.secondCategory){
          t.params[v]=obj.secondCategory[i]?obj.secondCategory[i].no:''
        }else{
          t.params[v]=''
          t.params.firstCategoryNo=this.$store.state.firstCategoryNo ? this.$store.state.firstCategoryNo :''
        }
      })
      this.params.teamNumber=obj.teamSize&&obj.teamSize[0]?obj.teamSize[0].ranges:''
      this.params.provinceNo=obj.locationAddresscode.provinceId;
      this.params.cityNo=obj.locationAddress?obj.locationAddresscode.cityId:'';
      this.params.areaNoList=obj.locationAddress?obj.locationAddress.map(v=>{return v.no}):[];
      if(obj.locationAddresscode.isAll){
        this.params.areaNoList=this.params.areaNoList[0]
      }
     if(obj.teamScreen&&obj.teamScreen.length==3){
        obj.teamScreen.map(v=>{
          if(v.key=='achievement')t.params.resultNum=v.name//业绩
          if(v.key=='machinery')t.params.machineryType=v.no//机械
          if(v.key=='equipment')t.params.equipmentType=v.no//设备
        })
      }
     if(obj.teamScreen&&obj.teamScreen.length==2){
          if(obj.teamScreen[0].key=='achievement'&&obj.teamScreen[1].key=='machinery'){
              t.params.resultNum=obj.teamScreen[0].name
              t.params.machineryType=obj.teamScreen[1].no
              t.params.equipmentType=null
          }else if(obj.teamScreen[1].key=='achievement'&&obj.teamScreen[0].key=='machinery'){
              t.params.resultNum=obj.teamScreen[1].name
              t.params.machineryType=obj.teamScreen[0].no
              t.params.equipmentType=null 
          }
          if(obj.teamScreen[0].key=='achievement'&&obj.teamScreen[1].key=='equipment'){
              t.params.resultNum=obj.teamScreen[0].name
              t.params.equipmentType=obj.teamScreen[1].no
              t.params.machineryType=null
          }else if(obj.teamScreen[1].key=='achievement'&&obj.teamScreen[0].key=='equipment'){
              t.params.resultNum=obj.teamScreen[1].name
              t.params.equipmentType=obj.teamScreen[0].no
              t.params.machineryType=null
          }
          if(obj.teamScreen[0].key=='machinery'&&obj.teamScreen[1].key=='equipment'){
              t.params.machineryType=obj.teamScreen[0].no
              t.params.equipmentType=obj.teamScreen[1].no
          }else if(obj.teamScreen[1].key=='machinery'&&obj.teamScreen[0].key=='equipment'){
              t.params.machineryType=obj.teamScreen[1].no
              t.params.equipmentType=obj.teamScreen[0].no
          }
      }
     if(obj.teamScreen&&obj.teamScreen.length==1){
        obj.teamScreen.map(v=>{
          if(v.key=='achievement')t.params.resultNum=v.name
          if(v.key=='equipment'){
            t.params.equipmentType=v.no
            t.params.machineryType=null
          }
          if(v.key=='machinery'){
            t.params.machineryType=v.no
            t.params.equipmentType=null
          }
        })
      }
      this.listFun();
    },
    getList(){
      this.param.page=1
      this.list = []
      this.loadingTrue = true
      this.listFun()
    }
  },
  mounted(){
    document.addEventListener("scroll", this.windowScroll);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.windowScroll);
  },
  provide(){
    return {
      cardListCom:this
    }
  },
  destroyed() {
    sessionStorage.clear("query")
    sessionStorage.clear("routerKey")
  }
}
</script>

<style lang="scss"  scoped>
.table {
  position: relative;
  width: 1198px;
  margin: 0 auto;
  overflow: hidden;
  min-height: 400px;
  background: white;
  border-top: none;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  border-bottom: 1px solid #e4e7ed;
  /deep/ .right {
    right:0
  }
}
.course-loading-wrap {
    display: flex;
    padding-top: 10px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    color: #999;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-top: none;
    border-bottom: none;
    .loading-icon {
      margin-left: 12px;
      font-size: 24px;
    }
  }
</style>


